export var VELT_SDK_VERSION = '4.7.0-beta.3';
export var VELT_SDK_INIT_EVENT = 'onVeltInit';
export var VELT_TAB_ID = 'veltTabId';
// integrity map for the Velt SDK
// Note: generate integrity hashes with: https://www.srihash.org/
export var INTEGRITY_MAP = {
    '4.7.0-beta.3': 'sha384-PzW8xYX/3cMZIQf7g79YWCaztC+Cc0a9e6NUyjPkfEbkyg6sl0q6XU0tkh1j6Ttv',
};
